import { isPre, isProd } from '../utils/common'

// 活动代号
export const activityCode = 'hundredyearcartoon'

// 分享图的背景config
export const sharePosterMap: any = {
  step1: {
    poster: 'film1_show',
  },
}

// 分享qrcode
export const qrCodeImg = {
  uat: '//i0.hdslb.com/bfs/ogv/activity/film-history/uat-qr.png',
  pre: '//i0.hdslb.com/bfs/ogv/activity/film-history/pre-qr.png',
  prod: '//i0.hdslb.com/bfs/ogv/activity/film-history/pro-qr.png',
}

export const currQrCodeImgSrc = isProd
  ? qrCodeImg['prod']
  : isPre
  ? qrCodeImg['pre']
  : qrCodeImg['uat']

// 右侧导航栏
export const rightNavList = [
  {
    src: '//i0.hdslb.com/bfs/ogv/activity/film-history/share-btn.png',
  },
  {
    src: '//i0.hdslb.com/bfs/ogv/activity/film-history/lottery-btn.png',
  },
]
// 高光时刻站点
export const highlightList = [
  {
    station: 10,
    name: '第一站',
    cover: '//i0.hdslb.com/bfs/ogv/activity/film-history/station-1.png',
    activeCover:
      '//i0.hdslb.com/bfs/ogv/activity/film-history/station-1-selected.png',
    workInfoSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-1.png',
    badgeSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/badge-1.pag',
    pagSrc:
      '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-meiying.pag',
    linkSrc:
      'https://www.bilibili.com/blackboard/topic/activity-XpanoQFJzG.html',
  },
  {
    station: 21,
    name: '第二站',
    cover: '//i0.hdslb.com/bfs/ogv/activity/film-history/station-2.png',
    activeCover:
      '//i0.hdslb.com/bfs/ogv/activity/film-history/station-2-selected.png',
    workInfoSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-2.png',
    badgeSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/badge-2.pag',
    pagSrc:
      '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-yangyang.pag',
    linkSrc:
      'https://www.bilibili.com/blackboard/topic/activity-dx5P76yKUa.html',
  },
  {
    station: 24,
    name: '第三站',
    cover: '//i0.hdslb.com/bfs/ogv/activity/film-history/station-3.png',
    activeCover:
      '//i0.hdslb.com/bfs/ogv/activity/film-history/station-3-selected.png',
    workInfoSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-3.png',
    badgeSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/badge-3.pag',
    pagSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-joke.pag',
    linkSrc:
      'https://www.bilibili.com/blackboard/topic/activity-54hPY0ZCUo.html',
  },
  {
    station: 26,
    name: '第四站',
    cover: '//i0.hdslb.com/bfs/ogv/activity/film-history/station-4.png',
    activeCover:
      '//i0.hdslb.com/bfs/ogv/activity/film-history/station-4-selected.png',
    workInfoSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-4.png',
    badgeSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/badge-4.pag',
    pagSrc: '//i0.hdslb.com/bfs/ogv/activity/film-history/highlight-dashen.pag',
    linkSrc:
      'https://www.bilibili.com/blackboard/topic/activity-5MdUogyjzZ.html',
  },
]

// 总站点个数
export const totoalStation = 31

// 氛围pag个数
export const atmospherePag = 27

// 各个节点的信息
const preShareSrc = '//i0.hdslb.com/bfs/ogv/activity/film-history/poster-'
export const workInfoMap: any = {
  step1: {
    year: '1922',
    txt1: '《舒振东华文打字机》',
    txt2: '中国第一部广告动画诞生',
    ssid: '',
    currStartTime: 2,
    currEndTime: 3,
    sharePoster: `${preShareSrc}1.jpg`,
  },
  step2: {
    year: '1926',
    txt1: '《大闹画室》',
    txt2: '中国第一部真正意义上的动画',
    ssid: '',
    currStartTime: 4,
    currEndTime: 5,
    sharePoster: `${preShareSrc}2.jpg`,
  },
  step3: {
    year: '1935',
    txt1: '《骆驼献舞》',
    txt2: '中国第一部有声动画',
    ssid: '',
    currStartTime: 5,
    currEndTime: 6,
    sharePoster: `${preShareSrc}3.jpg`,
  },
  step4: {
    year: '1941',
    txt1: '《铁扇公主》',
    txt2: '亚洲第一部动画长片',
    ssid: '32526',
    sharePoster: `${preShareSrc}4.jpg`,
  },
  step5: {
    year: '1947',
    txt1: '《皇帝梦》',
    txt2: '中国第一部木偶动画',
    ssid: '',
    sharePoster: `${preShareSrc}5.jpg`,
  },

  step6: {
    year: '1949',
    txt1: '上海电影制片厂成立',
    txt2: '处女作《谢谢小花猫》',
    ssid: '39906',
    sharePoster: `${preShareSrc}6.jpg`,
  },

  step7: {
    year: '1953',
    txt1: '《小小英雄》',
    txt2: '中国第一部彩色木偶动画',
    ssid: '',
    sharePoster: `${preShareSrc}7.jpg`,
  },

  step8: {
    year: '1955',
    txt1: '《乌鸦为什么是黑的》',
    txt2: '中国第一部彩色平涂动画',
    ssid: '',
    sharePoster: `${preShareSrc}8.jpg`,
  },

  step9: {
    year: '1956',
    txt1: '《骄傲的将军》',
    txt2: '民族风格动画开山之作',
    ssid: '39738',
    sharePoster: `${preShareSrc}9.jpg`,
  },

  // 站点1
  step10: {
    isStation: true,
    sharePoster: `${preShareSrc}10.jpg`,
  },

  step11: {
    year: '1958',
    txt1: '《猪八戒吃西瓜》',
    txt2: '中国第一部剪纸动画',
    ssid: '39808',
    sharePoster: `${preShareSrc}11.jpg`,
  },

  step12: {
    year: '1960',
    txt1: '《聪明的鸭子》',
    txt2: '中国第一部折纸动画',
    ssid: '39789',
    sharePoster: `${preShareSrc}12.jpg`,
  },

  step13: {
    year: '1961',
    txt1: '《大闹天宫》',
    txt2: '中国动画的巅峰之作诞生',
    ssid: '33220',
    sharePoster: `${preShareSrc}13.jpg`,
  },

  step14: {
    year: '1961',
    txt1: '《小蝌蚪找妈妈》',
    txt2: '中国第一部水墨动画',
    ssid: '39806',
    sharePoster: `${preShareSrc}14.jpg`,
  },

  step15: {
    year: '1979',
    txt1: '《哪吒闹海》',
    txt2: '中国第一部彩色宽荧幕动画',
    ssid: '2533',
    sharePoster: `${preShareSrc}15.jpg`,
  },

  step16: {
    year: '1983',
    txt1: '《天书奇谭》',
    txt2: '中国动画美学巅峰',
    ssid: '39733',
    sharePoster: `${preShareSrc}18.jpg`,
  },

  step17: {
    year: '1984',
    txt1: '《黑猫警长》',
    txt2: '中国电视动画代表作诞生',
    ssid: '',
    sharePoster: `${preShareSrc}16.jpg`,
  },

  step18: {
    year: '1986',
    txt1: '《葫芦兄弟》',
    txt2: '中国动画第二个繁荣时期代表作',
    ssid: '',
    sharePoster: `${preShareSrc}17.jpg`,
  },

  // step18: {
  //   year: '1989',
  //   txt1: '《舒克和贝塔》',
  //   txt2: '郑渊洁作品经典改编',
  //   ssid: '',
  //   sharePoster: `${preShareSrc}18.jpg`,
  // },

  step19: {
    year: '1999',
    txt1: '《宝莲灯》',
    txt2: '中国第一部商业动画电影',
    ssid: '',
    sharePoster: `${preShareSrc}19.jpg`,
  },

  step20: {
    year: '2001',
    txt1: '《我为歌狂》',
    txt2: '中国校园音乐动画鼻祖诞生',
    ssid: '',
    sharePoster: `${preShareSrc}20.jpg`,
  },

  // 站点2
  step21: {
    isStation: true,
    sharePoster: `${preShareSrc}21.jpg`,
  },

  step22: {
    year: '2006',
    txt1: '《虹猫蓝兔七侠传》',
    txt2: '中国武侠动画的开端',
    ssid: '5366',
    sharePoster: `${preShareSrc}22.jpg`,
  },

  step23: {
    year: '2011',
    txt1: '《罗小黑战记》',
    txt2: '中国萌系动画代表',
    ssid: '1733',
    sharePoster: `${preShareSrc}23.jpg`,
  },

  // 站点3
  step24: {
    isStation: true,
    sharePoster: `${preShareSrc}24.jpg`,
  },

  step25: {
    year: '2015',
    txt1: '《那年那兔那些事》',
    txt2: '中国教育类动画的飞跃之作',
    ssid: '1689',
    sharePoster: `${preShareSrc}25.jpg`,
  },

  // 站点4
  step26: {
    isStation: true,
    sharePoster: `${preShareSrc}26.jpg`,
  },

  step27: {
    year: '2016',
    txt1: '《大鱼海棠》',
    txt2: '2D与3D结合的Flash动画代表',
    ssid: '11890',
    sharePoster: `${preShareSrc}27.jpg`,
  },

  step28: {
    year: '2017',
    txt1: '《全职高手》',
    txt2: '网文改编、新时代走出国门代表',
    ssid: '27821',
    sharePoster: `${preShareSrc}28.jpg`,
  },

  step29: {
    year: '2019',
    txt1: '《白蛇：缘起》',
    txt2: '春节档斩获4.48亿票房',
    ssid: '',
    sharePoster: `${preShareSrc}29.jpg`,
  },
  step30: {
    year: '2019',
    txt1: '《哪吒之魔童降世》',
    txt2: '荣登当年中国票房影史第二',
    ssid: '',
    sharePoster: `${preShareSrc}30.jpg`,
  },

  step31: {
    // isStation: true,
    sharePoster: `${preShareSrc}31.jpg`,
  },
}

export const sceneList = [
  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg1.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin1.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip1.png',
    picW: '4.61rem',
    picH: '3.74rem',
    picLeft: '1.36rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-1.png',
    frontW: '1.42rem',
    frontH: '1.75rem',
    frontLeft: '0.5rem',
    frontTop: '61.88%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg2.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin2.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip2.png',
    picW: '4.78rem',
    picH: '4.9rem',
    picLeft: '2.67rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-2.png',
    frontW: '2.43rem',
    frontH: '4.91rem',
    frontLeft: '0rem',
    frontTop: '51.84%',
  },
  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg3.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin3.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip3.png',
    picW: '3.92rem',
    picH: '4.34rem',
    picLeft: '2.45rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-3.png',
    frontW: '1.86rem',
    frontH: '2.64rem',
    frontLeft: '0rem',
    frontTop: '60.59%',
  },
  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg4.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin4.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip4.png',
    picW: '4.31rem',
    picH: '5.17rem',
    picTop: '43%',
    picLeft: '1.64rem',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-4.png',
    frontW: '2.17rem',
    frontH: '2.75rem',
    frontLeft: '0rem',
    frontTop: '58.92%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg5.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin5.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip5.png',
    picW: '4.60rem',
    picH: '4.95rem',
    picLeft: '1.76rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-5.png',
    frontW: '2.01rem',
    frontH: '3.99rem',
    frontLeft: '0.17rem',
    frontTop: '57.45%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg6.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin6.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip6.png',
    picW: '2.63rem',
    picH: '5.05rem',
    picLeft: '2.58rem',
    picTop: '38%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-6.png',
    frontW: '2.14rem',
    frontH: '2.10rem',
    frontLeft: '0.29rem',
    frontTop: '61.08%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg7.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin7.png',
    bgColor: '#0c1106',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip7.png',
    picW: '3.88rem',
    picH: '4.89rem',
    picLeft: '1.74rem',
    picTop: '40.08%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-7.png',
    frontW: '3.67rem',
    frontH: '2.64rem',
    frontLeft: '-0.99rem',
    frontTop: '62.93%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg8.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin8.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip8.png',
    picW: '4.96rem',
    picH: '4.88rem',
    picLeft: '1.18rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-8.png',
    frontW: '2.52rem',
    frontH: '3.97rem',
    frontLeft: '0rem',
    frontTop: '54.61%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg9.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin9.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip9.png',
    picW: '5.35rem',
    picH: '7.04rem',
    picLeft: '1.45rem',
    picTop: '33.6%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-9.png',
    frontW: '2.31rem',
    frontH: '3.26rem',
    frontLeft: '0rem',
    frontTop: '61.82%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg40.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin40-1.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip40.png',
    picW: '6.21rem',
    picH: '5.84rem',
    picLeft: '0.79rem',
    picTop: '43.16%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-40.png',
    frontW: '1.28rem',
    frontH: '2.58rem',
    frontLeft: '0.15rem',
    frontTop: '56.80%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg10.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin10.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip10.png',
    picW: '6.17rem',
    picH: '6.58rem',
    picLeft: '0.48rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-10.png',
    frontW: '2.72rem',
    frontH: '2.76rem',
    frontLeft: '0.16rem',
    frontTop: '60.71%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg11.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin11.png',
    bgColor: '#1a1e35',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip11.png',
    picW: '3.89rem',
    picH: '4.62rem',
    picLeft: '1.92rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-11.png',
    frontW: '3.03rem',
    frontH: '4.43rem',
    frontLeft: '0rem',
    frontTop: '53.87%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg12.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin12.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip12.png',
    picW: '6.44rem',
    picH: '7.74rem',
    picLeft: '0.46rem',
    picTop: '38.05%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-12.png',
    frontW: '3.30rem',
    frontH: '3.96rem',
    frontLeft: '0rem',
    frontTop: '52.77%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg13.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin13.png',
    bgColor: '#131921',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip13.png',
    picW: '3.69rem',
    picH: '3.40rem',
    picLeft: '3.14rem',
    picTop: '46.61%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-13.png',
    frontW: '3.20rem',
    frontH: '2.45rem',
    frontLeft: '0rem',
    frontTop: '61.57%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg14.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin14.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip14.png',
    picW: '6.78rem',
    picH: '6.48rem',
    picLeft: '0rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-14.png',
    frontW: '2.78rem',
    frontH: '3.24rem',
    frontLeft: '0rem',
    frontTop: '55.97%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg50.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin50.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip50.png',
    picW: '4.66rem',
    picH: '3.41rem',
    picLeft: '1.6rem',
    picTop: '42%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-50.png',
    frontW: '2.55rem',
    frontH: '2.34rem',
    frontLeft: '0rem',
    frontTop: '62%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg16.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin16.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip16.png',
    picW: '6.18rem',
    picH: '5.01rem',
    picLeft: '0.48rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-16.png',
    frontW: '2.54rem',
    frontH: '2.38rem',
    frontLeft: '-0.08rem',
    frontTop: '63.91%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg17.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin17.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip17.png',
    picW: '5.51rem',
    picH: '4.64rem',
    picLeft: '1.1rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-17.png',
    frontW: '2.13rem',
    frontH: '3.32rem',
    frontLeft: '0rem',
    frontTop: '59.42%',
  },
  // {
  //   bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg18.png',
  //   bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin18.png',
  //   bgColor: '#0d0907',
  //   pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip18.png',
  //   picW: '7.02rem',
  //   picH: '6.69rem',
  //   picLeft: '0.09rem',
  //   picTop: '40%',
  //   front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-18.png',
  //   frontW: '2.71rem',
  //   frontH: '2.35rem',
  //   frontLeft: '0rem',
  //   frontTop: '63.30%',
  // },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg19.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin19.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip19.png',
    picW: '7.43rem',
    picH: '5.74rem',
    picLeft: '-0.4rem',
    picTop: '38%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-19.png',
    frontW: '1.95rem',
    frontH: '2.67rem',
    frontLeft: '0rem',
    frontTop: '62.25%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg20.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin20.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip20.png',
    picW: '4.80rem',
    picH: '5.17rem',
    picLeft: '1.6rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-20.png',
    frontW: '2.35rem',
    frontH: '3.64rem',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg41.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin41.png',
    bgColor: '#090e04',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip41.png',
    picW: '4.81rem',
    picH: '4.46rem',
    picLeft: '1.35rem',
    picTop: '40.20%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-41.png',
    frontW: '2.08rem',
    frontH: '3.83rem',
    frontLeft: '0rem',
    frontTop: '61.69%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg22.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin22.png',
    bgColor: '#281417',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip22.png',
    picW: '6.89rem',
    picH: '6.10rem',
    picLeft: '0rem',
    picTop: '34.86%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-22.png',
    frontW: '2.64rem',
    frontH: '6.12rem',
    frontLeft: '0rem',
    frontTop: '52.03%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg23.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin23.png',
    bgColor: '#0a0f05',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip23.png',
    picW: '5.51rem',
    picH: '5.73rem',
    picLeft: '0.75rem',
    picTop: '37.9%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-23.png',
    frontW: '2.74rem',
    frontH: '2.57rem',
    frontTop: '62.86%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg42.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin42.png',
    bgColor: '#1f1313',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip42.png',
    picW: '4.06rem',
    picH: '5.38rem',
    picLeft: '1.82rem',
    picTop: '40.33%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-42.png',
    frontW: '2.95rem',
    frontH: '2.45rem',
    frontLeft: '-0.4rem',
    frontTop: '64%',
  },
  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg25.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin25.png',
    bgColor: '#091529',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip26.png',
    picW: '6.69rem',
    picH: '6.56rem',
    picLeft: '0.59rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-25.png',
    frontW: '2.73rem',
    frontH: '2.61rem',
    frontLeft: '0rem',
    frontTop: '59.42%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg43.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin43.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip43.png',
    picW: '6.30rem',
    picH: '5.92rem',
    picLeft: '0.98rem',
    picTop: '38.23%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-43.png',
    frontW: '2.52rem',
    frontH: '3.73rem',
    frontLeft: '-0.28rem',
    frontTop: '52.77%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg27.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin27.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip27.png',
    picW: '3.96rem',
    picH: '5.91rem',
    picLeft: '1.92rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-27.png',
    frontW: '2.90rem',
    frontH: '3.07rem',
    frontLeft: '0rem',
    frontTop: '57.14%',
    frontAni: 'translation',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg28.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin28.png',
    bgColor: '#120302',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip28.png',
    picW: '5.84rem',
    picH: '6.19rem',
    picLeft: '1.66rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-28.png',
    frontW: '2.19rem',
    frontH: '5.49rem',
    frontLeft: '0.12rem',
    frontTop: '52.58%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg29.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin29.png',
    bgColor: '#140203',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip29.png',
    picW: '5.36rem',
    picH: '5.76rem',
    picLeft: '0rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-29.png',
    frontW: '2.43rem',
    frontH: '2.58rem',
    frontLeft: '0rem',
    frontTop: '64.22%',
  },

  {
    bg: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bg30.png',
    bgIn: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-bgin30.png',
    pic: '//i0.hdslb.com/bfs/ogv/activity/film-history/scene-ip30.png',
    picW: '3.42rem',
    picH: '5.57rem',
    picLeft: '2.37rem',
    picTop: '40%',
    front: '//i0.hdslb.com/bfs/ogv/activity/film-history/item-30.png',
    frontW: '3.17rem',
    frontH: '2.24rem',
    frontLeft: '0rem',
    frontTop: '63.73%',
    frontAni: 'translation',
  },

  {
    isLastPage: true,
  },
]
